import React from "react";
import {AgencyHeader} from "./AgencyHeader";
import {AgencyTabs} from "./AgencyTabs";
import AgencyClientsList from "./AgencyClientList";
import {ClientsContentBase} from "../ClientsContentBase";
import { withTranslation } from 'react-i18next';
import {useUiVersion} from "../../context/UserModulesContext";
import {AgencyClientsV2Content} from "./v2/AgencyClientsV2Content";


class AgencyClientsContentClass extends ClientsContentBase {
    render() {
        return (
            <section className="section-content">
                <AgencyHeader/>
                <AgencyTabs activeTab="-first"/>
                <div className="section-body h-items">
                    <AgencyClientsList doAgencyClientDelete={this.handleAgencyClientDelete}
                                       clients={this.state.clients}
                                       doClientStatusChange={this.handleAgencyClientStatusChange}
                                       afterSuccessfulAgencyClientSubmit={this.props.afterSuccessfulAgencyClientSubmit}
                    />
                </div>
                {this.renderActivationModal()}
            </section>
        )
    }
}

const AgencyClientsContentClassic = withTranslation()(AgencyClientsContentClass);

// Bifurcación UI v2: con el flag activo se monta el Listado de Clientes nuevo (UX 2.1); sin él, el
// camino es exactamente el de siempre. Para volver al clásico para todos alcanza con cambiar la
// línea del `if` por un `return <AgencyClientsContentClassic {...props}/>` directo.
export function AgencyClientsContent(props) {
    const {isV2} = useUiVersion();
    if (isV2) return <AgencyClientsV2Content {...props}/>;
    return <AgencyClientsContentClassic {...props}/>;
}
